import React from 'react';
import { TopBar } from './componentes/top-bar/top-bar';
import { SideMenu } from './componentes/side-menu/side-menu';
import { AppBarNavigation } from './componentes/app-bar-navigation/app-bar-navigation';
import { MobileMenu } from './componentes/side-menu/mobile-menu';
// import '@contentsys/contentsys-react-components/dist/index.css';

import { Layout } from 'antd';

import './App.css';

import { UserSession } from './componentes/user-session/user-session';
import { BrowserRouter as Router } from 'react-router-dom';

import { getMainMenuRouter } from './routers/router-principal';
import { Provider } from 'react-redux';
import reducer from './store/index'
import { createStore } from 'redux';
import { VerifyDomain } from './componentes/domain-verification/verify-domain';
const store = createStore(reducer);
console.log(store.getState());

class App extends React.Component {


  render = () => {

    const { Content } = Layout;

    return (
      <Provider store={store}>
        <VerifyDomain>
          <UserSession>

            <div className='App'>
              <AppBarNavigation></AppBarNavigation>

              <Router>

                <Layout className="mainLayout">

                  <MobileMenu></MobileMenu>
                  <SideMenu></SideMenu>

                  <Layout className="center-layout" id="mainLayout">
                    <TopBar></TopBar>
                    <Content className='main'>

                      {getMainMenuRouter()}

                    </Content>

                    {/* <Footer style={{
                      padding: "0",
                      paddingBottom: "15px",
                      marginTop: '0'
                    }} >Contentsys &copy; <Moment format="YYYY">{hoje}</Moment> - Todos os direitos reservados
                  </Footer> */}

                  </Layout>
                </Layout>
              </Router>
            </div>
          </UserSession>
        </VerifyDomain>
      </Provider>
    );
  }
}

export default App;
